<script>
    /* Executable code section of the program */


    /* End of the section */
</script>
<!-- Section to place the HTML code -->
<section class="emptyContainer">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-fill-x icon" viewBox="0 0 16 16">
        <path d="M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-9 8c0 1 1 1 1 1h5.256A4.5 4.5 0 0 1 8 12.5a4.5 4.5 0 0 1 1.544-3.393Q8.844 9.002 8 9c-5 0-6 3-6 4"/>
        <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m-.646-4.854.646.647.646-.647a.5.5 0 0 1 .708.708l-.647.646.647.646a.5.5 0 0 1-.708.708l-.646-.647-.646.647a.5.5 0 0 1-.708-.708l.647-.646-.647-.646a.5.5 0 0 1 .708-.708"/>
      </svg>
      <p>No attendees have registered for this event yet</p>
</section>


<!-- End of the section -->
<style>
    /* Section to place the code styles */
    .emptyContainer{
        width: 100%;
        height: 30vh;
        padding: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .icon{
        width: 70px;
        height: auto;
        margin: 15px 0;
    }

/* /////////Tablets///////// */
  @media (min-width: 700px) and (max-width: 1100px) {
    
}
/* /////////Cellphones ///////// */
@media (max-width: 700px) {
    .emptyContainer{
        width: 100%;
        padding: 10px;
    }
    p{
        width: 80%;
        text-align: center;
    }
    .icon{
        width: 40px;
        height: auto;
        margin: 15px 0;
    }
}


    /* End of the section */
</style>